import { defaultModalProps, Modal } from "../ModalComponent/Modal";
import { password_validation, text_validation, UseValidation } from "../../../components/DynamicForm/Helpers/validationMethods";
import "./change-password-modal.css";
import { useContext, useEffect, useRef, useState } from "react";
import DynamicForm from "../../DynamicForm/DynamicForm";
import { PATCH, POST } from "../../../utils/httpUtils";
import { UserContext } from "../../../context/UserContext";
import { LoaderContext } from "../../../context/LoaderContext";
import { AlertContext } from "../../../context/AlertContext";
import { Alert, Try } from "../../../utils/genericUtils";
import { useNavigate } from "react-router-dom";

const defaultProps = {
  ...defaultModalProps,
  onCancel: () => {},
  isResetFlow: false,
};

export default function ChangePasswordModal(props = defaultProps) {
  const valid = useRef(new Map());

  const router = useNavigate();

  const { user, loginUser } = useContext(UserContext);
  const { show, showloader, hideloader } = useContext(LoaderContext);
  const { globalAlert } = useContext(AlertContext);

  //password fields
  const [old_password, set_oldPassword] = useState("");
  const [new_password, set_newPassword] = useState("");
  const [confirm_password, set_confirmPassword] = useState("");

  UseValidation(valid);

  const isValid = () => ![...valid.current.values()].some((v) => v === false) && [...valid.current.values()].length == GetFields().length;

  const confirm_password_validation = (id, e, set_err) => {
    let message = undefined;
    //password validation last
    message = password_validation(id, e, set_err);

    //use event value as it is updated first
    if (!message && new_password !== e.target.value) {
      message = "Passwords do not match!";
    }

    if (message) set_err(message);
    valid.current.set(id, message === undefined);
  };

  //form fields
  const ChangePasswordFields = [
    {
      id: "old-password",
      name: "Old Password",
      type: "password",
      defaultValue: "",
      validationFunc: password_validation,
      onChange: (e) => set_oldPassword(e.target.value),
    },
    {
      id: "new-password",
      name: "New Password",
      type: "password",
      defaultValue: "",
      validationFunc: password_validation,
      onChange: (e) => set_newPassword(e.target.value),
    },
    {
      id: "confirm-password",
      name: "Confirm Password",
      type: "password",
      defaultValue: "",
      validationFunc: confirm_password_validation,
      onChange: (e) => set_confirmPassword(e.target.value),
    },
  ];

  async function ChangePassword() {
    showloader();
    let response = await PATCH(
      props.isResetFlow ? "/reset-password" : "/update-password",
      { old_password, new_password, confirm_password },
      user ?? { blank: "" }
    );
    props.onCloseModal();
    hideloader();

    if (response.success) {
      if (!props.isResetFlow) {
        Alert(globalAlert, "success", "Success", "Password successfully updated!");
      } else {
        Alert(
          globalAlert,
          "success",
          "Success",
          "Password successfully reset!",
          () => {
            sessionStorage.removeItem("password-reset-token");
            router("/login");
          },
          "Back to Login"
        );
      }
    } else {
      if (!props.isResetFlow) {
        Alert(globalAlert, "error", "Error", response.message ?? "Something went wrong!");
      } else {
        Alert(
          globalAlert,
          "error",
          "Error",
          response.message ?? "Something went wrong!",
          () => {
            sessionStorage.removeItem("password-reset-token");
            router("/login");
          },
          "Back to Login"
        );
      }
    }
  }

  function GetFields() {
    if (props.isResetFlow) {
      return [ChangePasswordFields[1], ChangePasswordFields[2]];
    } else return ChangePasswordFields;
  }

  return (
    <Modal
      id="change-password-modal"
      animate={props.animate ?? true}
      header={props.header ?? "Update Password"}
      message={props.message}
      showDivider={true}
      isActive={props.isActive}
      icon={props.icon}
    >
      <DynamicForm id="change-password-form" fields={GetFields()} layout={[1, 3]} />
      <div className="change-password-modal-controls">
        <button className="standard-button" onClick={props.onCancel}>
          Cancel
        </button>
        <button
          className="standard-button"
          disabled={!isValid() || new_password !== confirm_password}
          onClick={ChangePassword}
        >
          Submit
        </button>
      </div>
    </Modal>
  );
}
